import { CustomError } from 'ts-custom-error'

class StandardError extends CustomError {
  message: string

  meta: object

  constructor(message: string, meta: object = {}) {
    super(message)

    this.message = message
    this.meta = meta
  }
}

export default StandardError
